import PropTypes from "prop-types";
import { useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { Controller } from "react-hook-form";

const CountryForm = ({
  id,
  control,
  errors,
  label,
  labelLeft,
  labelRight,
  helperText,
  disabled,
  size,
}) => {
  const hasError = errors[id] !== undefined;

  const [items, setItems] = useState([
    { id: "", name: "Bitte wählen" },
    { id: "CH", name: "Schweiz" },
    { id: "DE", name: "Deutschland" },
    { id: "FR", name: "Frankreich" },
    { id: "IT", name: "Italien" },
    { id: "LI", name: "Fürstentum Liechtenstein" },
    { id: "AT", name: "Österreich" },
  ]);

  return (
    <Form.Group controlId={id} style={{ marginBottom: "1rem" }}>
      {label && <Form.Label>{label}</Form.Label>}
      <InputGroup size={size}>
        {labelLeft && (
          <InputGroup.Prepend>
            <InputGroup.Text>{labelLeft}</InputGroup.Text>
          </InputGroup.Prepend>
        )}
        <Controller
          name={id}
          control={control}
          render={({ field }) => (
            <select
              id={id}
              className={[
                "form-select",
                size ? `form-select-${size}` : "",
                hasError ? "is-invalid" : "",
              ].join(" ")}
              readOnly={disabled}
              {...field}
              // onChange={onChange}
              disabled={disabled}
            >
              {items.map((i) => (
                <option key={`${id}-${i.id}`} value={i.id}>
                  {i.name}
                </option>
              ))}
            </select>
          )}
        />
        {labelRight && (
          <InputGroup.Append>
            <InputGroup.Text>{labelRight}</InputGroup.Text>
          </InputGroup.Append>
        )}
      </InputGroup>
      {hasError && (
        <div className="invalid-feedback" style={{ display: "block" }}>
          {errors[id].message}
        </div>
      )}
      {helperText && <Form.Text muted>{helperText}</Form.Text>}
    </Form.Group>
  );
};

CountryForm.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    })
  ).isRequired,
  control: PropTypes.object.isRequired,
  errors: PropTypes.objectOf(PropTypes.any).isRequired,
  label: PropTypes.string,
  labelLeft: PropTypes.string,
  labelRight: PropTypes.string,
  helperText: PropTypes.string,
  disabled: PropTypes.bool,
  size: PropTypes.string,
  onChange: PropTypes.func,
};

CountryForm.defaultProps = {
  label: "",
  labelLeft: "",
  labelRight: "",
  helperText: "",
  disabled: false,
  size: "",
  onChange: null,
};

export default CountryForm;
